import { makeAutoObservable, runInAction } from "mobx"
import agent from "../api/agent"
import { AssetEquipment, AssetSetting } from "../models/asset"

/*
* etc includes padding and margin;
* formula: card - other - etc;
*/
interface ElementHeight {
  card: number;
  other: number;
  etc: number;
}

export class AssetStore {
  loadingEquipment: boolean = false
  systems: AssetEquipment[] = []
  assetSetting: AssetSetting = {type: null, id: null}
  elementsHeight: ElementHeight = {
    card: 0,
    other: 0,
    etc: 60,
  };
  
  constructor() {
    makeAutoObservable(this)
  }

  getEquipments = async (stationId: string) => {
    this.loadingEquipment = true;
    try {
      const res = await agent.Station.equipments(stationId)

      runInAction(() => this.systems = res)
    } catch (error) {
      throw error;
    } finally {
      runInAction(() => this.loadingEquipment = false)
    }
  }

  setAssetSetting = (assetSetting: AssetSetting) => {
    this.assetSetting = assetSetting;
  }
  clearAssetSetting = () => {
    this.assetSetting = { type: null, id: null }
  }

  setCardHeight = (card: number) => {
    this.elementsHeight = { ...this.elementsHeight, card }
  }

  setOtherHeight = (other: number) => {
    this.elementsHeight = { ...this.elementsHeight, other }
  }

  setEtcHeight = (etc: number) => {
    this.elementsHeight = { ...this.elementsHeight, etc }
  }
}
